export let routes = [
  {
    path: '/x3-side-role-mult',
    name: 'x3-side-role-mult',
    component: () => import('./role-mult.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];

export let api = {
  xsChooseRoleMult(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-role-mult',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};
